import useSettingsContext from '../../context/useSettingsContext';
import useDataContext from '../../context/useDataContext';
import usePostTypeParameter from './usePostTypeParameter';
import useCategoryParameter from './useCategoryParameter';
import useSearchParameter from './useSearchParameter';
import useOrderParameter from './useOrderParameter';
import useExcludeParameter from './useExcludeParameter';
import useTaxRelationParameter from './useTaxRelationParameter';
import useFieldsParameter from './useFieldsParameter';

function useLoadPosts() {
  const {
    currentPage,
    changedFilter,
    posts,
    setPosts,
    setMaxPages,
    setResults,
    setLoading,
    setChangedFilter
  } = useDataContext();

  const {postsPerPage} = useSettingsContext();
  const {paginationStyle} = useSettingsContext();
  const {postTypeParameter} = usePostTypeParameter();
  const {categoryParameter} = useCategoryParameter();
  const {searchParameter} = useSearchParameter();
  const {orderParameter} = useOrderParameter();
  const {excludeParameter} = useExcludeParameter();
  const {taxRelationParameter} = useTaxRelationParameter();
  const {fieldsParameter} = useFieldsParameter();

  const loadPosts = async function() {
    const requestURL = `${wp.home_url}/wp-json/wp/v2/${postTypeParameter()}?${categoryParameter()}${searchParameter()}page=${currentPage}&per_page=${postsPerPage}${orderParameter()}${excludeParameter()}${taxRelationParameter()}${fieldsParameter()}`;

    setLoading(true);

    let activeTermsCollection = new Map();
    let etnFiltersNavs = document.querySelectorAll('.eight29-filter');
    const url = new URL(location.origin + location.pathname);
    for (let etnFiltersNav of etnFiltersNavs) {
      let activeTerms = etnFiltersNav.querySelectorAll(".eight29-filter.filter-checkbox ul.checkboxes input[type=checkbox]:checked");
      activeTerms.forEach(activeterm => {
        let dataTerm = activeterm.getAttribute('name');
        let dataTax = activeterm.closest('ul').getAttribute('id');
        let newDataVal = '';
        dataTax = dataTax.replace('filter-', '');
        dataTax = dataTax.replace('-input', '');
        if(activeTermsCollection.has(dataTax)){
          newDataVal = activeTermsCollection.get(dataTax) + ', '+ dataTerm;
        } else {
          newDataVal = dataTerm;
        }
        activeTermsCollection.set(dataTax,newDataVal);
      });
    }
    for (let activeTermsSlug of activeTermsCollection) {
      url.searchParams.append('e29_' + activeTermsSlug[0], activeTermsSlug[1]);
    }
    history.pushState({}, '', url);

    const response = await fetch(requestURL);
    const data = await response.json();

    if (paginationStyle === 'more') {
      const postsCopy = changedFilter ? [] : [...posts];

      data.forEach(post => {
        postsCopy.push(post);
      });

      setPosts(postsCopy);
    }

    else {
      setPosts(data);
    }

    setMaxPages(parseInt(response.headers.get('X-WP-TotalPages')));
    setResults(parseInt(response.headers.get('X-WP-Total')));
    setLoading(false);
    setChangedFilter(false);
  }

  return {
    loadPosts
  }
}

export default useLoadPosts;